import { httpService } from '@/api/v1/http.service'
import type { AvailabilityForm } from '@/constants/availability-form'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'
import { parseAvailabilitySlots } from '@/modules/availabilityManagement'

const useSetRoomAvailability = (options?: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    ...options,
    mutationFn: async ({
      availabilityId,
      data
    }: {
      availabilityId: string
      data: AvailabilityForm
    }) => {
      const response = await httpService.panel.panelRoomsAvailabilityUpdate(
        availabilityId,
        {
          monday: parseAvailabilitySlots(data.monday ?? []),
          tuesday: parseAvailabilitySlots(data.tuesday ?? []),
          wednesday: parseAvailabilitySlots(data.wednesday ?? []),
          thursday: parseAvailabilitySlots(data.thursday ?? []),
          friday: parseAvailabilitySlots(data.friday ?? []),
          saturday: parseAvailabilitySlots(data.saturday ?? []),
          sunday: parseAvailabilitySlots(data.sunday ?? [])
        }
      )

      return response
    }
  })

export default useSetRoomAvailability
